// import { useEffect, useRef } from 'react';
import ComponentSections2ColumnMedia from '@/components/sections/ComponentSections2ColumnMedia';
import ComponentSectionsFullWidthMedia from '@/components/sections/ComponentSectionsFullWidthMedia';
import SidebarTabs from './SidebarTabs';
import RelatedProjects from './reletedProject';

type Project = {
  name: string;
  project_categories?: any;
  blocks?: {
    __typename?: string;
    [key: string]: any;
  }[];
  related_projects: any;
  video: any;
};

type ListViewProps = {
  setActiveTab: React.Dispatch<React.SetStateAction<'grid' | 'list' | 'detail' | 'video'>>;
  project: Project;
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
  totalSlides: number;
  activeTab: 'grid' | 'list' | 'detail' | 'video';
};

export default function ListView({
  setActiveTab,
  project,
  currentSlide,
  setCurrentSlide,
  totalSlides,
  activeTab,
}: ListViewProps) {
  const relatedProjects = project.related_projects;
  const videoEnable = project?.video?.enable_video_controls === true;

  // // Prevent scroll reset on tab change
  // const prevTabRef = useRef(activeTab);

  // useEffect(() => {
  //   if (prevTabRef.current !== activeTab) {
  //     prevTabRef.current = activeTab;
  //     // We’re preventing scroll resets here; don’t scroll to top
  //   }
  // }, [activeTab]);

  return (
    <section className="relative min-h-screen">
      <div className="grid grid-cols-12 relative gap-2 lg:gap-5">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2 listing-viewside bg-red">
          {activeTab === 'list' && (
            <div className="md:col-span-3 h-full">
              <SidebarTabs
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                projectName={project.name}
                position="sticky"
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                totalSlides={totalSlides}
                videoControlsEnabled={!!videoEnable}
              />
            </div>
          )}
        </div>

        <div className="col-span-12 lg:col-span-8 xl:col-span-9 list-project pt-3 px-4 md:px-0 lg:pt-7">
          {project?.blocks?.map((block: any, index: number) => {
            switch (block.__typename?.trim()) {
              case 'ComponentSections2ColumnMedia':
                return <ComponentSections2ColumnMedia key={index} data={block} />;
              case 'ComponentSectionsFullWidthMedia':
                return <ComponentSectionsFullWidthMedia key={index} data={block} />;
              default:
                return null;
            }
          })}
        </div>
      </div>
      <RelatedProjects relatedProjects={relatedProjects} />
    </section>
  );
}
